
















import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { Modules } from '../../store/store';
import { Locale } from '../../store/modules/config';
import { ARIA_REFS } from '../../config/accessibility';
import ChargingOption from './charging-option.vue';
import SubHeadline from '../sub-headline/sub-headline.vue';
import { SubBrand } from '@/store/modules/themes';
import ChargingOptionsGrid from './charging-options-grid.vue';
import ChargingOptionsGridUsa from './charging-options-grid-usa.vue';

const themeModule = namespace(Modules.themes);
const dataModule = namespace(Modules.chargingData);
const configModule = namespace(Modules.config);

@Component({
  name: 'eqweb-charging-options',
  components: { ChargingOption, SubHeadline, ChargingOptionsGrid, ChargingOptionsGridUsa },
})
export default class ChargingOptions extends Vue {
  @themeModule.Getter('subBrand')
  private readonly subBrand!: SubBrand;

  @dataModule.Getter('hasChargingOptions')
  private readonly hasChargingOptions!: boolean;

  @configModule.State('locale')
  private readonly locale!: Locale;

  @configModule.Getter('asSidebar')
  private readonly asSidebar!: boolean;

  private get ARIA_REFS() {
    return ARIA_REFS;
  }
}
